import * as React from 'react';
import {
    Grid, Card, TextField, CardContent, Box, 
    Typography, Divider,
    CircularProgress,
    CardActionArea,
    useTheme,
  } from '@mui/material'

import SearchCard from "components/SearchCard";
import constants from 'assets/constants';
import { stripAccents, fetchUserList } from 'assets/utils';
import { useTranslation } from "react-i18next";

function tokenSearch(list, s) {
    const tokens = s.split(" ");

    if (list === undefined || list == null) {
        return []
    }

    return list.filter(player => {
        const n = stripAccents(player["name"]);
        const c = stripAccents(player["name_club"].replace(".", ""));

        for (var i = 0; i < tokens.length; ++i) {
            const token = tokens[i];
            
            if (!n.includes(stripAccents(token)) && !c.includes(stripAccents(token))) {
                return false;
            }
        }

        return true;
    })
}

export default function UserSearchCard ({fetchData}) {

    const theme = useTheme();
    const { t } = useTranslation();

    return <SearchCard
        fetchData={fetchData}
        fetchList={fetchUserList}
        searchMethod={tokenSearch}
        MIN_LENGTH = {5}
        generalText={{placeholder: t("search.playerPlaceholder"), noResults: t("search.playerNoResults")}}
        listItem={(index, el, handleClick) => 
            <React.Fragment key={el["name"] + el["club_id"] + el["id"]}>
            {index > 0? <Divider/> : null}
            <CardActionArea onClick={()=>{handleClick(el)}} sx={{pl: 2, pt: 1, pb: 1}}>
            <Typography variant="body2" sx={{fontWeight: "bold"}}>{el["name"]}</Typography>
            <Typography variant="caption">{el["padel"] !== undefined ? <><b style={{color: theme.palette.primary.main}}>P{el["padel"]}</b><b> • </b></> : null}{el["name_club"]}</Typography>
            </CardActionArea>

            </React.Fragment>
        }
    />
}